export const SET_ACTIVE_ROW = '@preview/SET_ACTIVE_ROW';
export const FETCH_DATA_REQUEST = '@preview/FETCH_DATA_REQUEST';
export const FETCH_DATA_FAILURE = '@preview/FETCH_DATA_FAILURE';
export const FETCH_DATA_SUCCESS = '@preview/FETCH_DATA_SUCCESS';
export const FETCH_PREVIEW_SCHEMA_SUCCESS = '@preview/FETCH_PREVIEW_SCHEMA_SUCCESS';
